export default "__VITE_PUBLIC_ASSET__2fce088f__"